import PageShell from '@/pages/shared/PageShell';

const ITEMS = [
  { icon: 'ri-shield-check-line', title: '会社ごとの完全データ分離', desc: 'テナントごとにデータを分離し、他社の情報にアクセスできない設計です。' },
  { icon: 'ri-cloud-line', title: 'Google Cloud東京リージョン', desc: 'データはGoogle Cloudの東京リージョンで管理しています。日本国内のデータセンターで運用されます。' },
  { icon: 'ri-refresh-line', title: '毎日自動バックアップ', desc: 'データは毎日自動でバックアップされ、万が一の障害時にも迅速に復旧できます。' },
  { icon: 'ri-file-search-line', title: '監査ログ', desc: '誰がいつどの操作を行ったかを記録し、後から追跡・確認することが可能です。' },
  { icon: 'ri-lock-line', title: '権限管理', desc: 'メンバーごとに閲覧権限、編集権限、管理権限を細かく設定できます。' },
  { icon: 'ri-shield-keyhole-line', title: '通信の暗号化', desc: 'すべての通信はTLS 1.3で暗号化され、安全にデータを送受信します。' },
];

export default function Security() {
  return (
    <PageShell
      title="セキュリティ｜企業のプロジェクト情報を安全に管理｜”おもいむすび”"
      description="”おもいむすび”のセキュリティ対策。会社ごとのデータ分離、Google Cloud東京リージョン、毎日自動バックアップ、監査ログ、権限管理、通信の暗号化について。"
      keywords="プロジェクト管理 セキュリティ,データ分離,Google Cloud 東京,自動バックアップ,監査ログ"
      canonical="https://omoimusubi.asia/security/"
      h1="企業のプロジェクト情報を安全に管理"
      subtitle="”おもいむすび”は、企業の重要なプロジェクト情報を守るため、以下のセキュリティ対策を実施しています。"
      relatedLinks={[
        { label: '料金', path: '/pricing/' },
        { label: '無料トライアル', path: '/free-trial/' },
        { label: 'お問い合わせ', path: '/contact/' },
      ]}
    >
      <div className="not-prose mb-10 rounded-xl overflow-hidden border border-background-200/70">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20modern%20Japanese%20IT%20security%20professional%20a%20woman%20in%20her%2030s%20standing%20in%20a%20clean%20well%20lit%20server%20room%20or%20data%20center%20with%20neat%20rows%20of%20server%20racks%20blue%20indicator%20lights%20she%20is%20looking%20at%20a%20tablet%20showing%20security%20dashboard%20metrics%20the%20room%20is%20bright%20white%20and%20clean%20organized%20professional%20atmosphere%20Japanese%20corporate%20data%20center%20refreshing%20cool%20tones%20modern%20technology%20environment&width=1200&height=600&seq=security-hero-01&orientation=landscape"
          alt="セキュリティのイメージ - データセンターでセキュリティ管理を行うITプロフェッショナル"
          className="w-full h-auto"
        />
      </div>
      <div className="not-prose grid grid-cols-1 sm:grid-cols-2 gap-6 my-10">
        {ITEMS.map((item) => (
          <div key={item.title} className="flex items-start gap-4 bg-background-100 rounded-lg p-5 border border-background-200/70">
            <div className="w-10 h-10 bg-accent-100 rounded-lg flex items-center justify-center shrink-0">
              <i className={`${item.icon} text-accent-600 text-lg`}></i>
            </div>
            <div>
              <h3 className="text-sm font-bold text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <section>
        <h2>セキュリティに関する注意事項</h2>
        <p>当社はセキュリティを最優先に設計・運用していますが、現時点ではISO 27001、SOC 2等の第三者認証は取得しておりません。認証の取得状況については、最新情報をお問い合わせください。</p>
        <p>セキュリティに関するご質問や詳細な情報が必要な場合は、お問い合わせフォームよりご連絡ください。</p>
      </section>
    </PageShell>
  );
}